// extracted by mini-css-extract-plugin
export default {"root":"OzT01s","list":"l_GOoK","item":"lAgmEp"};